/*eslint-disable*/
import { FormikContext, useField } from 'formik';
import { useDevice } from 'hooks/useDevice';
import { useSafeField } from 'hooks/useSafeField';
import React, { FC, useEffect, useLayoutEffect, useRef, useState, useContext } from 'react';

interface SelectProps {
  options: { value?: string; label: string }[];
  placeholder?: string;
  className?:string;
  keyValue?:string;
  multiple?:boolean;
  caretPosition?:string;
  integratedSearchBar?:boolean;
  listClassName?:string;
  placeholderClassName?:string;
  onChange?: (value: any) => any;
  onFocus?:any,
  name?: string;
  customLabel?: (value:unknown)=>React.ReactNode;
  customValue?: (value:unknown)=>React.ReactNode;
  defaultValue?: unknown | unknown[] | string;
  noErrorHandling?:boolean; 
  listStyle?:Object; 
  inputClassName?:string;
  isAddon?:boolean;
  setAddonWasClicked?:any;
  searchable?:boolean;
  errors?: string;
  resetDomainsAndSkills?:any;
  [key:string]:unknown
}

let touchStartY = 0;
let hasMoved = false;

const   Select: FC<SelectProps> = ({ options,multiple=false, placeholder = 'Select',integratedSearchBar,listStyle, caretPosition='right-3',onChange,errors,customValue, defaultValue,name,isAddon,setAddonWasClicked, className='', resetDomainsAndSkills,listClassName,placeholderClassName,inputClassName,keyValue='value', noErrorHandling=false, searchable, customLabel, ...rest }) => {
  const [open,setOpen]:any =useState(false)
  const [label, setLabel]:any = useState('')  
  const [value, setValue]:any = useState('')  
  const [filteredOptions,setFilteredOptions]:any = useState([])
  const [selectedValues,setSelectedValues]:any= useState([])
  const formikContext = useContext(FormikContext);
  // const isFormikEnabled = !!(formikContext && name);
  const [field, meta]:any = useSafeField(name!)

  // console.log({field})

  const ref:any = useRef()

  // if(field.name === "language")  console.log({field,meta, name,formikContext,value,label})
  

  
  useEffect(()=>{
    

    if(onChange && label){
      // console.log({label,field,meta,name});
      
      (onChange as any)({
        target: { 
          name,
          value:  label, 
        },
      })


      setValue(label)
      setLabel('')
    }
  },[label])

  useEffect(()=>{
    if(defaultValue && !field.value) setLabel(defaultValue)
  },[defaultValue])

  useLayoutEffect(()=>{
    setFilteredOptions(options)
  },[options])

  // useEffect(()=>{
  //   if(!multiple && field.value)setValue(field.value)
  // },[field.value])


  const handleClickCapture =(e: any)=>{
    console.log({e})
    if(searchable)ref.current.innerHtml = ''
    setFilteredOptions(options)
    ref.current.focus()
  }

  useEffect(()=>{
   if(ref.current){
    ref.current.addEventListener('blur', (e:any)=>{
      // setOpen(false)
    })
   }
  },[])

  

  const  inputRef:any = useRef(null)
  console.log({open})

  const handleClick = (e:any)=>{
    setOpen(!open);
  
    console.log({"top": "top",setAddonWasClicked })
    if(setAddonWasClicked){
      console.log({"ok":"ok"})

      setAddonWasClicked((prev:any)=>!prev)
    } 
  }


  useEffect(()=>{
      // console.log({filteredOptions,value})
      if(!multiple)setValue(field.value)
        if(multiple){ setSelectedValues(field.value || []) ; console.log({field})}
   },[field.value])

   useEffect(()=>{
    // console.log({open})
   },[open])

   useEffect(()=>{
    if(!selectedValues.length && multiple ) setOpen(false)
    if(inputRef && inputRef?.current?.value){
      handleKeyDown({target:{value:''}}); //console.log({inputRef}); /*inputRef.current.focus();*/
    }
    
    // console.log({selectedValues})

    
    // if(onChange  && multiple){
      
    //   (onChange as any)({
    //     target: { 
    //       name,
    //       value:  selectedValues, 
    //     },
    //   })

    // }

   },[selectedValues])

  const handleFilter = (keyword:string)=>{
    // console.log({keyword:keyword.trim().replace(' ','')})
    if(keyword && keyword?.trim().replace(' ','')!=='\n') return options.filter((el:any)=>el.value.toLowerCase().includes(keyword.trim().replace(' ','').toLowerCase()));
    else return options;
  }

  const handleKeyDown = (e:any)=>{

    setOpen(true)
    const value = e.target.value;
    setValue(value)
    setFilteredOptions((prev:any)=>handleFilter(value))

    // console.log({value})
  }



  const handleChange = (e:any)=>{
    // console.log({e, event:e.key})
    setOpen(true)
    const value = e.target.value;
    setFilteredOptions((prev:any)=>handleFilter(value))
    // console.log({value})
  }

  const removeSelectedOption = (option: any) => {
    setSelectedValues(
      selectedValues.filter((val: any) => val[keyValue] !== option[keyValue])
    );
  };

  const itemEventHandlingLogic = (option:any, selectedValues:any,keyValue:any)=>{
      if(!multiple){
        // console.log({t:option[keyValue]})
        if(keyValue){
          setLabel(option[keyValue] || '');
        }else{
          setLabel(option)
        }

        setOpen(false);  

        // setFilteredOptions(options) 

      }else { 
       
        // cas ou le composant n'est pas wrapped with FormikContext
        if(formikContext){
          if(selectedValues.find((el:any)=>el[keyValue] === option[keyValue])){
            // EN mode si la valuer existe deja dans selectedValues bah je le retire sinon je l'ajoute
            formikContext.setFieldValue(field.name,selectedValues.filter((el:any)=>el[keyValue]!==option[keyValue])) 
          }else{
            console.log({option, selectedValues, keyValue, formikContext})
            formikContext.setFieldValue(field.name,[...selectedValues,option])
          }
        }else{
          if(selectedValues.find((el:any)=>el[keyValue] === option[keyValue])){
            setSelectedValues(selectedValues.filter((el:any)=>el[keyValue]!==option[keyValue])) 
          }else{
            setSelectedValues([...selectedValues,option])
          }
        }
        setOpen(false);  
      }

      
      if(setAddonWasClicked) setAddonWasClicked(false)
  }
  
  
  const {isLaptop} = useDevice()
  const listRef: any = useRef(null)
  
  useEffect(() => {

      const handleClickOutSide: any = (event: MouseEvent | TouchEvent) => {
    
        if(listRef.current && !listRef?.current?.contains(event.target)){
          if(ref.current && ref.current.contains(event.target)){
            setOpen(true)
          }else{
            setOpen(false)
            if(setAddonWasClicked){
        
              setAddonWasClicked((prev:any)=>!prev)
            } 
          }
        }


      
      }
      document.addEventListener('touchstart', handleClickOutSide)

      document.addEventListener('click', handleClickOutSide)


      return ()=>{
        removeEventListener('touchstart', handleClickOutSide)
        removeEventListener('click', handleClickOutSide)
      }


      
    }, []);
  

  return (
    <div className="relative w-full my-3 "  {...rest}  >
      
      <div
        className={`${!isAddon?'bg-white  ':'bg-transparent'} ${!open || !filteredOptions.length?'rounded-3xl':'rounded-tr-3xl rounded-tl-3xl'}  w-full ${multiple?'min-h-[50px]':'h-[50px]'} outline-none appearance-none text-gray-700  ${meta.touched && meta.error && !noErrorHandling ? 'ring-2 ring-red-500/50':''} ${className} `}
        defaultValue=""  
      >
        {/* {...(!searchable?{onClick:handleClick}:{onClickCapture:handleClickCapture})}  onMouseLeave={()=>setOpen(false)}*/}
        <div ref={ref}  className={`w-full text-[#6F6F6F]  ${!multiple?'truncate overflow-hidden pl-4 pr-8':'px-4 py-2'} ${placeholderClassName} cursor-pointer  ${searchable &&  !multiple && 'outline-none rounded-full  whitespace-nowrap'}`}    {...(!searchable?!isLaptop?{onTouchStartCapture:handleClick, onTouchStart:handleClickCapture}:{}:!isLaptop?{}:{})} {...(!searchable?isLaptop?{onClick:handleClick, onClickCapture:handleClickCapture}:{}:isLaptop?{}:{})}    onKeyDownCapture={(e)=>{ if(e.key === 'Enter')e.preventDefault();}}  onKeyUp={searchable?handleKeyDown:undefined}   style={{lineHeight: multiple?'':'50px'}} >
          {!searchable && !multiple && (customValue? customValue(field.value ? field.value : (label ? label: placeholder)): field.value ? field.value : (label ? label: placeholder))}
          {/* onClickCapture={handleClick}  */}
          {searchable && !multiple &&<input type="text"  value={customValue? customValue(value):value}  {...(isLaptop?{onClickCapture:handleClick}:{onTouchStartCapture:handleClick, onFocus: ()=>{
          if(resetDomainsAndSkills)resetDomainsAndSkills(); setOpen(true)}})} placeholder={placeholder} className={`outline-none  w-full ${inputClassName}`} onKeyDownCapture={(e)=>{ if(e.key === 'Enter')e.preventDefault();}} onChange={handleKeyDown}/>}
  
          {
            multiple && !searchable?( 
              selectedValues.length?
              <div className='flex  gap-y-2 items-center h-full px-2'>
                { 
                selectedValues.map((val: any) => (
                  <span
                    key={val[keyValue]}
                    className="inline-flex justify-between  bg-gray-200 px-2 rounded-full h-[2rem] mr-2 py-1 "
                  >
                    <div className='truncate overflow-hidden whitespace-nowrap '>{val.label}</div>
                    <button 
                      onClick={() => removeSelectedOption(val)}
                      onTouchStart={() => removeSelectedOption(val)}
                      className="ml-2 text-red-500"
                    >
                      &times;
                    </button>
                  </span>
                ))}
              </div>:<div className='pl-4 flex items-center leading-8'>{placeholder}</div>
            ):null
          }
          {
            multiple && searchable ?( 
              selectedValues.length?
              <div className='inline-flex  flex-wrap   gap-y-2' >
                  { 
                  selectedValues.map((val: any) => (
                    <span  className="inline-flex justify-between  bg-primary-blue text-white px-2 rounded-full h-[2rem] mr-2 py-1 ">
                      <div className='truncate overflow-hidden whitespace-nowrap '>{val.label}</div>
                      <button 
                          onClick={() => removeSelectedOption(val)}
                          onTouchStart={() => removeSelectedOption(val)}
                          className="ml-2 text-white"
                        >
                          &times;
                      </button>
                    </span>
                  ))}
                {/* </div> */}
                {/* onClickCapture={handleClick}  */}
                <input type="text" value={value} ref={inputRef} placeholder='Rechercher...' {...rest} {...(isLaptop?{onClickCapture:handleClick}:{})} {...(!isLaptop?{onTouchStartCapture:handleClick}:{})} className={`outline-none  mr-4 w-[30%] ${inputClassName}`} onBlur={(e)=>console.log({e})} onKeyDownCapture={(e)=>{ if(e.key === 'Enter')e.preventDefault();}} onChange={handleKeyDown}/>
              </div>
              :<div className='flex items-center  leading-8'><input type="text" value={value} {...rest} placeholder={placeholder} onFocus={handleClick}  className={`outline-none w-full ${selectedValues.length?'':''} ${inputClassName}`} onKeyDownCapture={(e)=>{ if(e.key === 'Enter')e.preventDefault();}} onChange={handleKeyDown}/></div>
            ):null
          }
        </div>
        {open && (  
          <ul
            ref={listRef}
            onPointerMoveCapture={() => setOpen(true)}
            style={listStyle}
            className={`bg-white   max-h-[8rem] ${filteredOptions.length?'border':''}   w-full outline-none ${!open?'':' rounded-br-3xl rounded-bl-3xl'} overflow-y-scroll absolute z-50 ${listClassName}`}>
            {integratedSearchBar && (
            <li className='p-4'>
              <input type="text" className='border w-full outline-none mb-4' onChange={handleChange} />
            </li>)}
            {/* onClick={()=>itemEventHandlingLogic(option,selectedValues,keyValue)} {...(isLaptop?{onClick:()=>itemEventHandlingLogic(option,selectedValues,keyValue)}:{})}  {...(!isLaptop?{onTouchStart:()=>itemEventHandlingLogic(option,selectedValues,keyValue)}:{})}  */}
            {filteredOptions.map((option:any) => (
              <li  key={option.value}   data-value={option.value} onTouchStart={(e) => {
                touchStartY = e.touches[0].clientY;
                hasMoved = false;
              }}
              onTouchMove={(e) => {
                const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
                if (deltaY > 10) hasMoved = true; // le doigt a vraiment bougé
              }}
              onTouchEnd={(e) => {
                if (!hasMoved) {
                  itemEventHandlingLogic(option,selectedValues,keyValue);
                }
              }}
              onMouseDown={() => {
                itemEventHandlingLogic(option,selectedValues,keyValue); // pour desktop
              }}   className={`hover:bg-[#6f6f6f3b] px-4 py-2 cursor-pointer ${
                selectedValues.find(
                  (val: any) => val[keyValue] === option[keyValue]
                )
                  ? 'bg-gray-300'
                  : ''
              }`}>
              {!customLabel?option.label: customLabel(option)}
                </li>
              ))}
          </ul>
        )}
      </div>
      {!multiple ? (
        <div className={`absolute inset-y-0  flex items-center pointer-events-none  ${caretPosition}`}>
          {
            !open || !filteredOptions.length? (
              <svg
                className="w-4 h-4 text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            ) :
            (
              <svg
                className="w-4 h-4 text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                  clipRule="evenodd"  
                />
              </svg>

            )
          }
          
        </div>

      ) : null}
      {meta.error && !noErrorHandling && Object.keys(meta.error).length ? (<span className="absolute text-xs text-red-400">{meta.error}</span>): null}
    </div>
  );
};

export default Select;
